<template>
  <v-app>
    <v-main>
      <v-container class="content-container">
        <v-row justify="center" align="center" class="fill-height">
          <v-col cols="12" sm="8" md="6" lg="4">
            <v-card class="pa-5 text-center">
              <v-icon color="error" size="64">mdi-close-circle</v-icon>
              <h2 class="mb-4">Uh oh!</h2>
              <p>This page does not exist. Let's take you back to the <router-link to="/">real world</router-link>. </p>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

   </v-app>
 </template>

 <script>
 import router from '@/router'

export default {
   name: 'NotFound',
   data() {
   },
}
 </script>


<style>
  .content-container {
    height: 70%;
    display: flex;
  }
</style>
